import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./editorStyles.css";
const WYSIWYGEditor = ({ value, onChange }) => {
  const toolbarOptions = [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image", "video"],
    [
      {
        color: [
          "#000000",
          "#e60000",
          "#ff9900",
          "#ffff00",
          "#008a00",
          "#0066cc",
          "#9933ff",
          "#ffffff",
          "#facccc",
          "#ffebcc",
          "#ffffcc",
          "#cce8cc",
          "#cce0f5",
          "#ebd6ff",
          "#bbbbbb",
          "#f06666",
          "#ffc266",
          "#ffff66",
          "#66b966",
          "#66a3e0",
          "#c285ff",
          "#888888",
          "#a10000",
          "#b26b00",
          "#b2b200",
          "#006100",
          "#0047b2",
          "#6b24b2",
          "#444444",
          "#5c0000",
          "#663d00",
          "#666600",
          "#003700",
          "#002966",
          "#3d1466",
          "#1D91FF",
          " #AFD2FF",
          "#CAE1C4",
          " #687D6C",
          "#FDE8E3",
          "#C39E95",
        ],
      },
      {
        background: [
          "#000000",
          "#FF0000",
          "#00FF00",
          "#0000FF",
          "#FF00FF",
          "#00FFFF",
          "#FFFF00",
          "#FFA500",
        ],
      },
    ],
    [{ align: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ font: [] }],
  ];
  return (
    <div className="react-quill-container">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={{
          toolbar: toolbarOptions,
        }}
      />{" "}
    </div>
  );
};

export default WYSIWYGEditor;
